import jwt_decode from "jwt-decode";
import * as cookie from "cookie";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

export const tokenCookieName = process.env.NEXT_PUBLIC_TEACHER_COOKIE_NAME!;

export function deleteAllCookies() {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export function getCookieToken(cookies: any) {
  const token = cookies
    ?.split(";")
    .find((i: any) => i.trim().startsWith(`${tokenCookieName}=`))
    ?.split("=")[1];
  return token;
}

export function parseJwt(token: string) {
  const base64Url = token?.split(".")[1];
  const base64 = base64Url?.replace(/-/g, "+").replace(/_/g, "/");

  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function isExpireToken(cookies: any) {
  if (!cookies) return false;
  const token = getCookieToken(cookies);
  const payload: any = jwt_decode(token);
  const currentTime = new Date().getTime() / 1000;
  return payload?.expires_at > currentTime;
}

export const setCookieEncryptToken = async ({ token }: { token: string }) => {
  const encryptedToken = CryptoJS.AES.encrypt(
    token,
    `${process.env.NEXT_PUBLIC_RESPONSE_BODY_ENCRYPTION}`
  ).toString();

  Cookies.set(tokenCookieName, encryptedToken);
};

export const getCookieDecryptToken = () => {
  if (typeof document === "undefined") return null;

  const token = cookie.parse(document.cookie)[tokenCookieName];
  if (!token) return null;

  try {
    const decrypted = CryptoJS.AES.decrypt(
      token,
      `${process.env.NEXT_PUBLIC_RESPONSE_BODY_ENCRYPTION}`
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
};
